module.exports = __webpack_public_path__ + "front/img/i6.57a2fb10.png";